import { 
  LOAD_AUTOMATIONS_REQUEST, LOAD_AUTOMATIONS_SUCCESS, LOAD_AUTOMATIONS_FAILURE,
  CREATE_AUTOMATION_REQUEST, CREATE_AUTOMATION_SUCCESS, CREATE_AUTOMATION_FAILURE
} from "./AutomationTypes";

const initialState = {
  loading: false,
  creating: false,
  items: [],
  error: null,
};

export function automationReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_AUTOMATIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case LOAD_AUTOMATIONS_SUCCESS:
      return { ...state, loading: false, items: action.payload };
    case LOAD_AUTOMATIONS_FAILURE:
      return { ...state, loading: false, error: action.error };

    case CREATE_AUTOMATION_REQUEST:
      return { ...state, creating: true, error: null };
    case CREATE_AUTOMATION_SUCCESS:
      return {
        ...state,
        creating: false,
        items: [action.payload, ...state.items],
      };
    case CREATE_AUTOMATION_FAILURE:
      return { ...state, creating: false, error: action.error };

    default:
      return state;
  }
}